'use client';

import { useRouter, usePathname } from 'next/navigation';
import { buildUrlFromApiPagination } from '@/libs/api-pagination';

export function useApiPagination() {
  const router = useRouter();
  const pathname = usePathname();

  function goTo(apiUrl) {
    if (!apiUrl) return;

    const frontendUrl = buildUrlFromApiPagination(apiUrl, pathname);

    router.push(frontendUrl);
    // If you prefer not to pollute history, use:
    // router.replace(frontendUrl);
  }

  return { goTo };
}
